import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FileService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
import { CustomValidators } from 'src/utils/custom-validators/custom-validators';
import { CheckFolderExistenceValidator } from '../../validators/check-folder-existence-validator';

@UntilDestroy()
@Component({
    selector: 'ca-check-existence-of-item-dialog',
    templateUrl: './check-existence-of-item-dialog.component.html',
    styleUrls: ['./check-existence-of-item-dialog.component.scss'],
})
export class CheckExistenceOfItemDialogComponent implements OnInit {
    @Input() title: string;
    @Input() inputLabel: string;
    @Input() confirmText: string;
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    @Input() oldName: string | '';
    @Input() checkExistenceType: 'folder';
    formGroup: UntypedFormGroup;

    constructor(
        private activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private fileService: FileService,
        private activatedRoute: ActivatedRoute,
    ) {}

    close(): void {
        this.activeModal.close();
    }

    dismiss(): void {
        this.activeModal.dismiss('canceled');
    }

    submit(): void {
        this.activeModal.close(this.formGroup.value.name.trim());
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            name: [
                this.oldName,
                {
                    validators: [Validators.required, CustomValidators.NotContainingOnlyWhitespaces()],
                },
            ],
        });

        if (this.checkExistenceType === 'folder') {
            this.activatedRoute.queryParamMap
                .pipe(untilDestroyed(this))
                .pipe(
                    tap(queryParamMap => {
                        const currentFolderId: string | undefined = queryParamMap.get('folderId') || undefined;
                        this.formGroup.get('name')?.addAsyncValidators([CheckFolderExistenceValidator.createValidator(this.fileService, currentFolderId)]);
                    }),
                )
                .subscribe();
        }
    }
}
